import { render, staticRenderFns } from "./ResourceDropTree.vue?vue&type=template&id=21b0bc5c&"
import script from "./ResourceDropTree.vue?vue&type=script&lang=js&"
export * from "./ResourceDropTree.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDropTree.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports